import React from 'react'
import PropTypes from 'prop-types'
import {
    Text,
    Box,
    Image,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getUrl} from '../../../../utils/cloudinary-utils'

export const HeroXXValueBadge = ({
    variant = 'default',
    desktopPromotionPosition = 'top-right',
    mobilePromotionPosition = 'top-right',
    desktopPromotionBackground = 'white',
    mobilePromotionBackground = 'white',

    titleText,
    titleFontFamily = 'caslon',
    titleColor = 'black',
    titleTag = 'p',

    subTitleText,
    subTitleFontFamily = 'caslon',
    subTitleColor = 'black',
    subTitleTag = 'p'
}) => {
    const styles = useMultiStyleConfig('HeroXxValueBadge', {variant})

    const getTextTransform = (fontFamily) => {
        if (fontFamily === 'brandon-grotesque') {
            return 'uppercase'
        } else if (fontFamily === 'caslon-italic') {
            return 'lowercase'
        } else {
            return 'none'
        }
    }

    const titleTextTransform = getTextTransform(titleFontFamily)
    const subTitleTextTransform = getTextTransform(subTitleFontFamily)

    const renderTitle = (text) => {
        return text.split('$').map((part, index) => (
            <React.Fragment key={index}>
                {index > 0 && (
                    <Text
                        as="span"
                        position="absolute"
                        top={{base: '14px', lg: '14px'}}
                        left={{base: '11px', lg: '12px'}}
                    >
                        <Image
                            {...styles.titleDollarSign}
                            alt="Dollar Sign"
                            src={getUrl('UIImages/images/dollar-sign2-italic.svg')}
                        />
                    </Text>
                )}
                {part}
            </React.Fragment>
        ))
    }

    const hasDollarSign = titleText?.includes('$') ?? false

    return (
        titleText && (
            <Box
                background={{base: mobilePromotionBackground, lg: desktopPromotionBackground}}
                left={{
                    base: mobilePromotionPosition === 'top-left' ? '15px' : 'initial',
                    xs: mobilePromotionPosition === 'top-left' ? '30px' : 'initial'
                }}
                right={{
                    base: mobilePromotionPosition === 'top-right' ? '15px' : 'initial',
                    xs: mobilePromotionPosition === 'top-right' ? '30px' : 'initial'
                }}
                {...styles.wrapper}
                display={{
                    base: mobilePromotionPosition !== 'hide' ? 'block' : 'none',
                    lg: desktopPromotionPosition !== 'hide' ? 'block' : 'none'
                }}
            >
                {titleText && (
                    <Text
                        as={titleTag}
                        fontFamily={titleFontFamily}
                        color={titleColor}
                        {...styles.title}
                        textTransform={titleTextTransform}
                        fontStyle={titleFontFamily === 'caslon-italic' ? 'italic' : 'normal'}
                        marginLeft={{
                            base: hasDollarSign ? '14px' : '0',
                            lg: hasDollarSign ? '17px' : '0'
                        }}
                    >
                        {renderTitle(titleText)}
                    </Text>
                )}

                {subTitleText && (
                    <Text
                        as={subTitleTag}
                        fontFamily={subTitleFontFamily}
                        color={subTitleColor}
                        {...styles.subTitle}
                        textTransform={subTitleTextTransform}
                        fontStyle={subTitleFontFamily === 'caslon-italic' ? 'italic' : 'normal'}
                    >
                        {subTitleText}
                    </Text>
                )}
            </Box>
        )
    )
}

HeroXXValueBadge.propTypes = {
    variant: PropTypes.string,

    desktopPromotionPosition: PropTypes.string,
    mobilePromotionPosition: PropTypes.string,
    desktopPromotionBackground: PropTypes.string,
    mobilePromotionBackground: PropTypes.string,

    titleText: PropTypes.string,
    titleFontFamily: PropTypes.string,
    titleColor: PropTypes.string,
    titleTag: PropTypes.string,

    subTitleText: PropTypes.string,
    subTitleFontFamily: PropTypes.string,
    subTitleColor: PropTypes.string,
    subTitleTag: PropTypes.string
}

export default HeroXXValueBadge
